export default __webpack_public_path__ + "static/media/medicationTransmitOff.fac0dc7e.svg";